import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TodayFeed from "./components/TodayFeed";
import Collections from "./components/Collections";
import HotAndTalk from "./components/HotAndTalk";
import CtaFooter from "./components/CtaFooter";

export default function Home() {
  return (
    <div id="top">
      <Navbar />
      <main>
        <Hero />
        <TodayFeed />
        <Collections />
        <HotAndTalk />
      </main>
      <CtaFooter />
    </div>
  );
}